export default __webpack_public_path__ + "static/media/resume-folder.203dcef6.svg";